import {
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAIL,
  FORGOT_SUBDOMAIN_REQUEST,
  FORGOT_SUBDOMAIN_SUCCESS,
  FORGOT_SUBDOMAIN_FAIL,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  LOAD_RESET_PASSWORD_REQUEST,
  LOAD_RESET_PASSWORD_SUCCESS,
  LOAD_RESET_PASSWORD_FAIL,
} from 'constants/action_types'
import graphql from 'api/graphql'

export function doForgotPassword(email, subdomain) {
  return dispatch => {
    dispatch({ type: FORGOT_PASSWORD_REQUEST, data: { email, subdomain } })

    const mutation = `
      mutation SendForgotPasswordMail($input: AccountForgotPasswordInput!) {
        sendForgotPasswordMail(input: $input) {
          message
          valid
        }
      }
    `
    const variables = { input: { subdomain, email } }

    return graphql(null, mutation, variables)
      .then(res => {
        const { message, valid } = res.json.data.sendForgotPasswordMail
        dispatch({
          type: valid ? FORGOT_PASSWORD_SUCCESS : FORGOT_PASSWORD_FAIL,
          data: { message, valid },
        })
      })
      .catch(e => {
        console.error(e) // eslint-disable-line
        dispatch({
          type: FORGOT_PASSWORD_FAIL,
          data: { message: 'Error occurred, please try again in a moment' },
        })
      })
  }
}

export function doForgotSubdomain(email) {
  return dispatch => {
    dispatch({ type: FORGOT_SUBDOMAIN_REQUEST, data: { email } })

    const mutation = `
      mutation SendForgotSubdomainMail($input: AccountForgotSubdomainInput!) {
        sendForgotSubdomainMail(input: $input) {
          message
          valid
        }
      }
    `
    const variables = { input: { email } }

    return graphql(null, mutation, variables)
      .then(res => {
        const { message, valid } = res.json.data.sendForgotSubdomainMail
        dispatch({
          type: valid ? FORGOT_SUBDOMAIN_SUCCESS : FORGOT_SUBDOMAIN_FAIL,
          data: { message, valid },
        })
      })
      .catch(e => {
        console.error(e) // eslint-disable-line
        dispatch({
          type: FORGOT_SUBDOMAIN_FAIL,
          data: { message: 'Error occurred, please try again in a moment' },
        })
      })
  }
}

export function doChangePasswordWithResetToken(
  token,
  password,
  passwordConfirm,
  authCode
) {
  return dispatch => {
    dispatch({
      type: CHANGE_PASSWORD_REQUEST,
      data: { token, password, passwordConfirm, authCode },
    })

    const mutation = `
      mutation ChangePasswordWithResetToken($input: ChangePasswordInput!) {
        changePasswordWithResetToken(input: $input) {
          message
          valid
        }
      }
    `
    const variables = {
      input: {
        reset_password_token: token,
        password,
        password_confirm: passwordConfirm,
        auth_code: authCode,
      },
    }

    return graphql(null, mutation, variables)
      .then(res => {
        const { message, valid = false } =
          res.json.data.changePasswordWithResetToken || {}

        const returnMessage = valid
          ? message
          : message || 'Error occurred, please try again in a moment'

        dispatch({
          type: valid ? CHANGE_PASSWORD_SUCCESS : CHANGE_PASSWORD_FAIL,
          data: {
            message: returnMessage,
            valid,
          },
        })
        return { message: returnMessage, valid }
      })
      .catch(e => {
        console.error(e) // eslint-disable-line
        if (
          e &&
          e.errors &&
          e.errors[0] &&
          e.errors[0].originalError &&
          e.errors[0].originalError.passwordConfirmation
        ) {
          return dispatch({
            type: CHANGE_PASSWORD_FAIL,
            data: {
              message: 'Error occurred, passwords do not match',
              missingToken: true,
            },
          })
        }
        return dispatch({
          type: CHANGE_PASSWORD_FAIL,
          data: { message: 'Error occurred, please try again in a moment' },
        })
      })
  }
}

export function doLoadResetPasswordRequest(token) {
  return dispatch => {
    dispatch({
      type: LOAD_RESET_PASSWORD_REQUEST,
    })

    const query = `
      query ResetPasswordRequestQuery($resetPasswordToken: ID!) {
        resetPasswordRequest(reset_password_token: $resetPasswordToken) {
          id
          require2fa
        }
      }
    `

    const variables = {
      resetPasswordToken: token,
    }

    return graphql(null, query, variables)
      .then(res => {
        const { id, require2fa } = res.json.data.resetPasswordRequest
        dispatch({
          type: LOAD_RESET_PASSWORD_SUCCESS,
          data: { id, require2fa },
        })
      })
      .catch(e => {
        console.error(e) // eslint-disable-line
        if (
          e &&
          e.errors &&
          e.errors[0] &&
          e.errors[0].message &&
          e.errors[0].message.indexOf('404') > -1
        ) {
          return dispatch({
            type: LOAD_RESET_PASSWORD_FAIL,
            data: {
              message: 'Reset password token has expired',
              missingToken: true,
            },
          })
        }
        return dispatch({
          type: LOAD_RESET_PASSWORD_FAIL,
          data: {
            message: 'Error occurred, please reload the page',
            missingToken: false,
          },
        })
      })
  }
}
